export default {"src":"https://cdn2.e-farm.com/website-static/_next/static/media/el.f699deaf.svg","height":18,"width":27,"blurWidth":0,"blurHeight":0};